import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Ease } from '../_app/cuchillo/utils/Ease';
import Header from '../layout/Header';
import { ScrollItem__Default } from './ScrollItem__Default';
import ImagesCursor from '../components/ImagesCursor';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import Sidemenu from '../_app/cuchillo/layout/Sidemenu';
import { isMobile } from '../_app/cuchillo/core/Basics';

class ScrollItem__BlockLanding extends ScrollItem__Default {
  imagesCursor;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._call = () => this.loop();

    if (!isMobile) {
      const visor = GetBy.class('__canvas', __link)[0];
      this.imagesCursor = new ImagesCursor(visor, __link);

      EventDispatcher.addEventListener(Sidemenu.ON_SHOW, () => { this.imagesCursor.center = true; }, 'images_cursor');
    }
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
  triggerShow() {
    super.triggerShow();
    if (!isMobile) this.imagesCursor.show();
    gsap.ticker.add(this._call);
  }

  triggerHide() {
    super.triggerHide();
    if (!isMobile) this.imagesCursor.hide();
    gsap.ticker.remove(this._call);
  }

  triggerMove() {
    super.triggerMove();

    if (isMobile) return;

    if (this.progressInside < 0) {
      Header.show();
    } else {
      Header.hide();
    }
  }

  loop() {
    if (!isMobile) this.imagesCursor.loop();
  }

  resize() {
    super.resize();
    if (!isMobile) this.imagesCursor.resize();
  }

  dispose() {
    super.dispose();

    if (!isMobile) {
      this.imagesCursor.hide();
      this.imagesCursor.dispose();
      EventDispatcher.removeEventListener(Sidemenu.ON_SHOW, 'images_cursor');
    }
  }
}

Scroll._registerClass('BlockLanding', ScrollItem__BlockLanding);
